
export default function routes($stateProvider) {
	$stateProvider
		.state('storeFormPage', {
			url: '/store-create',
			template: require('./storeForm.html'),
			resolve: {
				loggedIn: ['User', function (User) {
					return User.requireLogin();
				}],
				zones: ['Zone', function (Zone) {
					return Zone.all();
				}]
			},
			controller: 'StoreFormController',
			controllerAs: 'storeForm'
		});
}

routes.$inject = ['$stateProvider'];



// WEBPACK FOOTER //
// ./src/page/storeForm/storeForm.routes.js